import { Output, EventEmitter, Injectable } from '@angular/core';
import { DialogUtility } from '@syncfusion/ej2-popups';

@Injectable({
    providedIn: 'root'
})
export class HelperService {
    toast: any = null;

    getVersion() {
        return '1.0.0';
    }

    alert(msg: string) {
        if (this.toast) {
            let info = { title: '', content: msg, cssClass: 'e-toast-success' }
            this.toast.show(info);
        }
    }

    alertFailed(msg: string, title: string = null) {
        if (this.toast) {
            if (title == null)
                this.toast.show({ title: '', content: msg, cssClass: 'e-toast-danger' });
            else
                this.toast.show({ title: title, content: msg, cssClass: 'e-toast-danger' });
        }
    }

    confirm(msg: string, callback: any) {
        DialogUtility.confirm({
            title: 'Confirmation',
            content: msg,
            okButton: { text: 'OK', click: function () { this.hide(); callback() } },
            //cancelButton: { text: 'Cancel', click: this.cancelClick.bind(this) },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' }
        });
    }
}
